import { gql } from '@apollo/client';

const PartnerNoteInfo = gql`
  fragment PartnerNoteInfo on PartnerNote {
    id
    message
    partnerNoteableId
    partnerNoteableType
    partnerNoteable {
      id
      name
    }
    adminUser {
      id
      firstName
      lastName
    }
    createdAt
    updatedAt
  }
`;

export default PartnerNoteInfo;
